module.exports = __webpack_public_path__ + "assets/shopping.232bbd1d.svg";